const AdminSupportComplaint = () => {
  return <div>Support complaint</div>;
};

export {AdminSupportComplaint};
